import { render } from "./AddFloorComponent.vue?vue&type=template&id=486c0174&scoped=true"
import script from "./AddFloorComponent.vue?vue&type=script&lang=js"
export * from "./AddFloorComponent.vue?vue&type=script&lang=js"

import "./AddFloorComponent.vue?vue&type=style&index=0&id=486c0174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486c0174"]])

export default __exports__